// dotenv 사용 예시
export const BASE_URL = process.env.BASE_URL;
export const API_KEY = process.env.API_KEY;
export const USER_NAME = process.env.USER_NAME;
export const ADMIN_EMAIL = process.env.ADMIN_EMAIL;
